var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchieveLastingImpactSectionImageMob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "234px",
    height: "919px",
    viewBox: "0 0 234 919",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "achieve-lasting-impact-section-image-mob") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exports",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "achieve-lasting-impact-section-image-mob",
    transform: "translate(17, 17)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 99.5,
    y1: 100.5,
    x2: 99.5,
    y2: 899.5,
    id: "Line",
    stroke: "#10575D",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 16.6666667,
    fill: "#348389",
    cx: 100,
    cy: 100,
    r: 108.333333
  }), /*#__PURE__*/React.createElement("g", {
    id: "search-sort-svgrepo-com",
    transform: "translate(50, 71.6667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1740573,11.0998858 C34.7676269,21.045063 36.0179453,34.1069116 44.1934021,42.6457819 C52.2372465,51.0648425 65.1784939,52.381454 74.7416881,45.7543581 C76.752004,44.3652131 78.5442562,42.6820486 80.0577995,40.7612076 C81.5461817,38.8720999 82.7565003,36.7783443 83.651336,34.5440552 C85.487459,29.9543719 85.9622961,24.9301356 85.0190734,20.0762234 C84.0906894,15.2663493 81.7855357,10.8331958 78.3868373,7.31778473 C75.0391065,3.84343272 70.7275078,1.46051477 66.0126847,0.478917074 C61.3165712,-0.484288216 56.4398132,0.0127601673 52.0320858,1.90368117 C47.5830683,3.81778697 43.8024357,7.01942618 41.1740573,11.0998858 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 9.61289786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8939192,36.8288587 C80.7345715,35.2486658 77.7074847,35.7259617 76.1339416,37.8941936 C74.5603984,40.0624255 75.0358807,43.1004112 77.1958735,44.6799565 L82.8939192,36.8288587 Z M92.3119525,55.7348306 C94.4713002,57.3143759 97.498387,56.8377275 99.0719301,54.6694956 C100.645473,52.5012637 100.169991,49.4632781 98.0099982,47.8837328 L92.3119525,55.7348306 Z M17.7418768,30.7613065 C20.4141905,30.7613065 22.5805704,28.587246 22.5805704,25.9041562 C22.5805704,23.2217139 20.4141905,21.0470058 17.7418768,21.0470058 L17.7418768,30.7613065 Z M4.83869366,21.0470058 C2.16637993,21.0470058 -2.47579734e-14,23.2217139 -2.47579734e-14,25.9041562 C-2.47579734e-14,28.587246 2.16637993,30.7613065 4.83869366,30.7613065 L4.83869366,21.0470058 Z M17.7418768,50.1899078 C20.4141905,50.1899078 22.5805704,48.0158473 22.5805704,45.3327575 C22.5805704,42.6503152 20.4141905,40.4756071 17.7418768,40.4756071 L17.7418768,50.1899078 Z M4.83869366,40.4756071 C2.16637993,40.4756071 -2.47579734e-14,42.6503152 -2.47579734e-14,45.3327575 C-2.47579734e-14,48.0158473 2.16637993,50.1899078 4.83869366,50.1899078 L4.83869366,40.4756071 Z M24.1934683,11.3329642 C26.865782,11.3329642 29.032162,9.15832089 29.032162,6.47581391 C29.032162,3.79330693 26.865782,1.61866359 24.1934683,1.61866359 L24.1934683,11.3329642 Z M4.83869366,1.61866359 C2.16637993,1.61866359 -2.47579734e-14,3.79330693 -2.47579734e-14,6.47581391 C-2.47579734e-14,9.15832089 2.16637993,11.3329642 4.83869366,11.3329642 L4.83869366,1.61866359 Z M77.1958735,44.6799565 L92.3119525,55.7348306 L98.0099982,47.8837328 L82.8939192,36.8288587 L77.1958735,44.6799565 Z M17.7418768,21.0470058 L4.83869366,21.0470058 L4.83869366,30.7613065 L17.7418768,30.7613065 L17.7418768,21.0470058 Z M17.7418768,40.4756071 L4.83869366,40.4756071 L4.83869366,50.1899078 L17.7418768,50.1899078 L17.7418768,40.4756071 Z M24.1934683,1.61866359 L4.83869366,1.61866359 L4.83869366,11.3329642 L24.1934683,11.3329642 L24.1934683,1.61866359 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0, 300)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 16.6666667,
    fill: "#348389",
    cx: 100,
    cy: 100,
    r: 108.333333
  }), /*#__PURE__*/React.createElement("g", {
    id: "nurse-svgrepo-com",
    transform: "translate(58.3333, 55)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1819444,58.1106081 C29.1777778,57.1385001 37.0532407,65.9117632 40.5886574,69.8501526 L40.5891204,69.8506109 C41.0166667,70.3268109 41.3805556,70.7324288 41.6666667,71.0413401 C42.0791667,70.6238058 42.6479167,70.0091915 43.3310185,69.2708294 L43.3310185,69.2708294 C47.1342593,65.1607972 54.4837963,57.2184778 58.1513889,58.1106081 C70.6608796,61.1538881 83.3333333,67.3593837 83.3333333,76.6945537 L83.3333333,91.6666667 L0,91.6666667 L0,76.6945537 C0,67.3593837 12.6724537,61.1538881 25.1819444,58.1106081 Z M64.8148148,73.33205 L69.4444444,73.33205 L69.4444444,77.9153031 L64.8148148,77.9153031 L64.8148148,82.4985563 L60.1851852,82.4985563 L60.1851852,77.9153031 L55.5555556,77.9153031 L55.5555556,73.33205 L60.1851852,73.33205 L60.1851852,68.7487969 L64.8148148,68.7487969 L64.8148148,73.33205 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5571759,3.18414636 C28.8719907,1.83880115 35.799537,0 41.6666667,0 C47.5337963,0 54.4613426,1.83880115 58.7759259,3.18414636 C62.5974537,4.37570051 64.3372685,8.49826795 62.912037,12.0256083 L57.7048611,27.2048156 C57.2372685,28.3618578 55.9215278,28.9370561 54.7428241,28.4993554 C46.0076389,25.2564747 37.3256944,25.2564747 28.5905093,28.4993554 C27.4118056,28.9370561 26.0960648,28.3618578 25.6284722,27.2048156 L20.4212963,12.0256083 C18.9960648,8.49826795 20.7358796,4.37570051 24.5571759,3.18414636 Z M43.9814815,11.4581328 L48.6111111,11.4581328 L48.6111111,16.0413859 L43.9814815,16.0413859 L43.9814815,20.6246391 L39.3518519,20.6246391 L39.3518519,16.0413859 L34.7222222,16.0413859 L34.7222222,11.4581328 L39.3518519,11.4581328 L39.3518519,6.87487969 L43.9814815,6.87487969 L43.9814815,11.4581328 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9493056,24.6342981 C27.5814815,27.5769757 25.462963,31.8751505 25.462963,36.666025 C25.462963,45.5254533 32.7175926,52.707411 41.6666667,52.707411 C50.6157407,52.707411 57.8703704,45.5254533 57.8703704,36.666025 C57.8703704,31.8751505 55.7518519,27.5769757 52.3840278,24.6342981 L55.4476852,21.198004 C59.7689815,24.9739171 62.5,30.5056745 62.5,36.666025 C62.5,48.0565548 53.1726852,57.2906641 41.6666667,57.2906641 C30.1606481,57.2906641 20.8333333,48.0565548 20.8333333,36.666025 C20.8333333,30.5056745 23.5643519,24.9739171 27.8856481,21.198004 L30.9493056,24.6342981 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0, 600)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 16.6666667,
    fill: "#348389",
    cx: 100,
    cy: 100,
    r: 108.333333
  }), /*#__PURE__*/React.createElement("g", {
    id: "speed-alt-svgrepo-com",
    transform: "translate(58.3333, 58.3333)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8.33333333
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.203903,71.6666667 C6.37672172,65.7950682 2.40834055,58.3150642 0.800633942,50.1712321 C-0.807072669,42.0279248 0.0180306135,33.5865509 3.17167307,25.9156897 C6.32531552,18.2446187 11.6658306,11.6880441 18.5179066,7.07509513 C25.3699305,2.46214612 33.4254948,0 41.6666318,0 C49.9077688,0 57.9634894,2.46214612 64.8155654,7.07509513 C71.6676414,11.6880441 77.0077398,18.2446187 80.1613823,25.9156897 C83.3150247,33.5865509 84.1405447,42.0279248 82.5327339,50.1712321 C80.9249231,58.3150642 76.9566982,65.7950682 71.1296211,71.6666667",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.6666318,
    y1: 41.9812207,
    x2: 62.4999428,
    y2: 31.4859155,
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchieveLastingImpactSectionImageMob);
export default __webpack_public_path__ + "static/media/achieve-lasting-impact-section-image-mob.adb0e85212a06d4a64b8fbe3a1630445.svg";
export { ForwardRef as ReactComponent };